import { AUTH_STATUS, useAuthStore } from './authStore';
import { useBillingStore } from './billingStore';
import { useDailyStatsStore } from './dailyStatsStore';
import { useTransactionStore } from './transactionStore';
import { useTgTransactionStore } from './tgTransactionStore';

// Phase 6: Single place to fully clear app state on logout.
export const clearAllStores = () => {
  useAuthStore.setState({
    status: AUTH_STATUS.UNAUTHENTICATED,
    accessToken: null,
    refreshToken: null,
    email: null,
    locationId: null,
  });

  useBillingStore.setState({
    cards: [],
    billingHistory: [],
    profile: null,
    lastFetched: { cards: 0, history: 0, profile: 0 },
    loading: { cards: false, history: false, profile: false },
    fetchErrors: { cards: null, history: null, profile: null },
  });
  if (useBillingStore.persist?.clearStorage) {
    useBillingStore.persist.clearStorage();
  }

  useDailyStatsStore.setState({
    loading: false,
    summary: {},
    chartData: [],
    timeZone: '',
    selectedDate: new Date(),
    lastFetched: 0,
  });

  useTransactionStore.setState({
    logs: [],
    summary: {},
    lastDocId: '',
    totalLogs: 0,
    loading: false,
    timeZone: '',
    lastFetched: 0,
  });

  useTgTransactionStore.setState({
    logs: [],
    summary: {},
    lastDocId: '',
    totalLogs: 0,
    loading: false,
    timeZone: '',
    lastFetched: 0,
  });
};
